import React from 'react'
import { Empty, Spin } from 'antd'

const PageStatus = ({ type }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 190px)'
    }}
  >
    {type === 'loading' && <Spin tip="Loading..."></Spin>}
    {type === 'empty' && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
  </div>
)

export default PageStatus
